(function () {
    'use strict';

    angular
        .module('app.tasks')
        .directive('taskCells', taskCells);

    taskCells.$inject = [ 'opsIncludeVersion']
    /* @ngInject */
    function taskCells(opsIncludeVersion) {
        
        var directive = {
            restrict: 'A',
            link: link,
            scope: {
                'item': '=',
                'completions': '=',
                'completionTypes': '=',
                'notes': '=',
                'canEdit': '&'
            },
            templateUrl: 'app/tasks/_taskCells.html?v=' + opsIncludeVersion
        };

        return directive;

        function link(scope, element, attrs) {
        }
    }

})();
